module.exports = __webpack_public_path__ + "static/media/bot.0dce5345.jpg";